import FormCard from "./FormCard";
import bannerImage from "../assets/backgroundImg.png"
import logo from "../assets/logoImg.png";
import WhatsAppChatButton from "./WhatsApp";

const Banner = () => {
  return (
    <section
      className="relative min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${bannerImage})`,
      }}
    >

      {/* Hero Navbar (embedded) */}
      <div className="relative z-10 max-w-7xl mx-auto px-4">
        <div className="h-16 grid grid-cols-3 items-center text-white">
          
          {/* Left */}
          <div className="flex justify-end items-center">
            <button className="text-sm font-bold text-black sm:text-md hover:underline focus:outline-none">
              HOME
            </button>
          </div>

          {/* Center */}
          <div className="flex justify-center">
            <img
              src={logo}
              alt="Logo"
              className="h-9 sm:h-12 md:h-15"
            />
          </div>

          {/* Right */}
          <div className="flex justify-start items-center">
            <button className="text-sm text-black font-bold sm:text-base hover:underline focus:outline-none">
              CONTACT US
            </button>
          </div>

        </div>
      </div>

      {/* Centered Card */}
      <div className="relative z-10 flex items-center justify-center min-h-[calc(100vh-4rem)] px-4">
        <FormCard />
      </div>

      <WhatsAppChatButton />
    </section>
  );
};

export default Banner;